import React from "react"
import { ClientReviewSummaryModalProps } from "../types"
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Modal } from "react-bootstrap";
import ThemedModal from "../../../utilities/ThemedModal";
import { DialogBody } from "./DialogBody";
import LoadingMessage from "../../../loaders/LoadingMessage";
import { ModalMessageContainer } from "../../../messages/ModalMessageContainer";
import Button from "../../../buttons";
import { useClientReviewsSummary } from "../hooks/useClientReviewsSummary";
import ReviewSummaryCard from "./ReviewSummaryCard";

const ClientReviewSummaryModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    masterAccountId,
    masterAccountName,
    reviewId,
    show,
    size = "xl",
    ...rest
} : Readonly<ClientReviewSummaryModalProps>) => {

    const [bodyAnimation] = useAutoAnimate();

    const onClose = () => cancel!();

    const { 
        results, 
        isNextPageLoading, 
        isError, 
        error, 
        clear, 
        hasMore, 
        loadMore, 
        reload, 
        totalCount 
    } = useClientReviewsSummary(masterAccountId);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header className="border-0">
                {!isNextPageLoading && (
                    <Modal.Title>Review Summary - {masterAccountName}</Modal.Title>
                )}
                {isNextPageLoading && (
                    <Modal.Title>Review Summary loading...</Modal.Title>
                )}
            </ThemedModal.Header>
            <DialogBody ref={bodyAnimation}>
                {isNextPageLoading && !results && (
                    <LoadingMessage text="Please wait while we get the Review Summary" />
                )}
                {!isNextPageLoading && (!results || error) && (
                    <ModalMessageContainer variant="danger" text="There was a problem getting the Review summary." />
                )}
                {!isNextPageLoading && (!error && isError === false) && results.length === 0 && (
                    <ModalMessageContainer variant="danger" text="There are no reviews to display." />
                )}
                {!error && (results && results.length > 0) && (
                    <>
                        {results.map((summary, i) => <ReviewSummaryCard data={summary} isActive={reviewId != null && summary.reviewId === reviewId} />)}
                        {hasMore && (
                            <div className="d-flex justify-content-center align-items-end mt-2">
                                <a href="#" onClick={loadMore}>Load more...</a>
                            </div>
                        )}
                    </>
                )}
                {isNextPageLoading && results.length > 0 && (
                    <div className="my-2">
                        <ModalMessageContainer variant="primary" text="Loading more reviews.." />
                    </div>

                )}
            </DialogBody>
            <Modal.Footer>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ClientReviewSummaryModal;